"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = __importDefault(require("react-jss"));
const avatar_styles_1 = __importDefault(require("./avatar.styles"));
class ProfileAvatar extends react_1.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, src, className } = this.props;
            return (jsx_runtime_1.jsx("img", { className: classnames_1.default(classes.profileMask, className), src: src, alt: "" }, void 0));
        };
    }
}
ProfileAvatar.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    src: prop_types_1.default.string,
    className: prop_types_1.default.string
};
ProfileAvatar.defaultProps = {
    className: null,
    src: null
};
exports.default = react_jss_1.default(avatar_styles_1.default)(ProfileAvatar);
//# sourceMappingURL=index.js.map